import { render, staticRenderFns } from "./JtInfoCard.vue?vue&type=template&id=2bc682be&scoped=true"
import script from "./JtInfoCard.vue?vue&type=script&lang=js"
export * from "./JtInfoCard.vue?vue&type=script&lang=js"
import style0 from "./JtInfoCard.vue?vue&type=style&index=0&id=2bc682be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc682be",
  null
  
)

export default component.exports